module.exports = __webpack_public_path__ + "img/mp4.b22e02ca.png";